import { Heading } from "../../../../atoms";
import { Flex } from "../../../../cores";
import { useViewContext } from "../../../../hooks";
import { IKeyStringAndValue } from "../../../../types/Types";
import GuaranteePointsDescription from "./GuaranteePointsDescription";

interface IGuaranteeDescription {
  emptyFilterOptions: boolean;
  filterOptions: IKeyStringAndValue | undefined;
  descriptionTitle: string;
  descriptionText: Array<string>;
}
const GuaranteeDescription = ({
  emptyFilterOptions,
  filterOptions,
  descriptionTitle,
  descriptionText,
}: IGuaranteeDescription) => {
  const { isMobile } = useViewContext();
  return !emptyFilterOptions ? (
    (filterOptions as IKeyStringAndValue)["typeOfPump"] !== "fl" ? (
      <Flex
        sx={{
          order: 1,
          width: ["100%", null, "50%", "25%", "25%"],
          flexDirection: "column",
          "> div": {
            marginY: 10,
            "> p": {
              marginLeft: "sm",
              fontSize: ["xs", null, "16px", null, null],
            },
          },
        }}
      >
        <Heading as={"h4"} variant={!isMobile ? "h5" : "h6"}>
          {descriptionTitle}
        </Heading>
        <GuaranteePointsDescription valueApproved={descriptionText[0]} />
      </Flex>
    ) : null
  ) : null;
};

export default GuaranteeDescription;
